// extracted by mini-css-extract-plugin
export var authorNameStyle = "quote_block-module--authorNameStyle--dn1py";
export var clientLogoStyle = "quote_block-module--clientLogoStyle--J50gb";
export var quoteAttributionStyle = "quote_block-module--quoteAttributionStyle--Sq9lG";
export var quoteBodyStyle = "quote_block-module--quoteBodyStyle--MDvfX";